import CONFIG from 'isomorphic-config'
import analytics from '@/shared-utils/analytics'
import isAbortSignalTimeoutSupported from '@/shared-utils/is-abortSignal-supported'
import {
  LocationSearchTypeWithNearbyAirports,
  processLocationSearchData
} from './utils'

function isLocationSearchType(
  data: unknown
): data is LocationSearchTypeWithNearbyAirports[] {
  if (!Array.isArray(data)) {
    return false
  }

  return data.every(
    item => typeof item === 'object' && item !== null && 'type' in item
  )
}

async function fetchNearbyAirports(searchValue: string) {
  const signalOption = isAbortSignalTimeoutSupported()
    ? { signal: AbortSignal.timeout(3500) }
    : {}
  const locationConfig = CONFIG.client.typeahead.location
  const url = `${locationConfig.endpoint.flightsNearbyAirport}?queryText=${searchValue}${locationConfig.querystring.flightsNearbyAirport}`
  try {
    const response = await fetch(url, { ...signalOption })
    const data = await response.json()
    if (isLocationSearchType(data?.matchedRegions)) {
      return processLocationSearchData(data.matchedRegions)
    }
    analytics.logError({
      message:
        'Error in fetchNearbyAirports. data not in LOCATION_SEARCH_TYPE format',
      data
    })
    return []
  } catch (error) {
    if ((error as Error).name === 'TimeoutError') {
      analytics.logError({
        message: `Timeout reached while invoking Nearby airports typeahead fetch. ${JSON.stringify(
          { error }
        )}`
      })
    } else {
      analytics.logError({
        message: `Failed to fetch nearby aiports typeahead results ${JSON.stringify(
          {
            error
          }
        )}`
      })
    }
    return []
  }
}

export default fetchNearbyAirports
